import { render, staticRenderFns } from "./ListEntitySimple.vue?vue&type=template&id=35728e38"
import script from "./ListEntitySimple.vue?vue&type=script&lang=js"
export * from "./ListEntitySimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports